import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'renci-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.css']
,
})
export class SessionExpiredComponent {
  constructor(private activeModal: NgbActiveModal) {
  }

  public signIn() {
    this.activeModal.close(true);
  }

  public signOut() {
    this.activeModal.close(false);
  }
}
